module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0103.jpg?v=e4293d60";